/**
 * This file was auto-generated by Fern from our API Definition.
 */

import * as Truvity from '../../api/index';
import * as core from '../../core';
import * as serializers from '../index';

export const NotInRevision: core.serialization.ObjectSchema<serializers.NotInRevision.Raw, Truvity.NotInRevision> =
    core.serialization.object({
        values: core.serialization.list(core.serialization.number()),
    });

export declare namespace NotInRevision {
    export interface Raw {
        values: number[];
    }
}
